<template>
    <div class="profile-admin-page">
        <div>
            <div class="container" v-if="!openProfileConfig && !showProfileData">
                <div class="row">
                    <div class="col-md-12">
                        <div class="title-button">
                            <h2>{{ title }}</h2>
                        </div>
                    </div>
                </div>

                <div class="panel-table-admin radius-6">
                    <div class="row head">
                        <div class="col-md-6">
                            <h6>{{ title }} cadastrados na plataforma</h6>
                            <div class="font-14">Subtitulo aqui</div>
                        </div>

                        <div class="col-md-6 text-right buttons">
                            <b-button
                                variant="dark"
                                size="sm"
                                class="icon-button display-inline-flex"
                                v-print="printObj"
                            >
                                <b-icon icon="download" aria-hidden="true"></b-icon>
                                Exportar
                            </b-button>
                        </div>
                    </div>

                    <div class="filters display-flex">
                        <div class="filter-field">
                            <label for="search-field">Pesquisar</label>

                            <b-input-group class="search-field right-space">
                                <b-input-group-prepend>
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                </b-input-group-prepend>

                                <b-form-input placeholder="Pesquisar" v-model="searchFieldText"></b-form-input>
                            </b-input-group>
                        </div>

                        <b-form-group label="Status" label-for="status" class="filter-field">
                            <b-form-select
                                id="status"
                                name="status"
                                v-model="status.selected"
                                :options="status.options"
                            ></b-form-select>
                        </b-form-group>
                    </div>

                    <div id="profile-content">
                        <b-table
                            :items="getTableData"
                            :fields="getMessageFields"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :busy="false"
                            class="mt-3"
                            hover
                            responsive
                        >
                            <template #cell(nome_organizacao)="data">
                                <span class="table-name" @click="setShowProfileData(data.item)">
                                    {{ data.item.nome_organizacao }}
                                </span>
                            </template>

                            <template #cell(id_status)="data">
                                <span class="status" :class="statusOptions[data.item.id_status].key">
                                    {{ statusOptions[data.item.id_status].value }}
                                </span>
                            </template>

                            <template #cell(actions)="data">
                                <div class="actions display-flex items-center">
                                    <div
                                        class="link"
                                        @click="
                                            openProfileConfig = true
                                            profileSelected = data.item
                                        "
                                        v-if="[2, 3].includes(getUserStatusProfile)"
                                    >
                                        Autorizar
                                    </div>

                                    <div @click="openBlockModal(data.item)" v-if="[2].includes(getUserStatusProfile)">
                                        <LockPP :statusLock="0" />
                                    </div>

                                    <div @click="openDeleteModal(data.item)" v-if="[2].includes(getUserStatusProfile)">
                                        <i class="far fa-trash-alt"></i>
                                    </div>
                                </div>
                            </template>
                        </b-table>
                    </div>

                    <div class="mt-3" v-if="getTableData.length > 0">
                        <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="rows"></b-pagination>
                    </div>
                </div>
            </div>

            <div class="container profile-config" v-if="openProfileConfig">
                <div class="row">
                    <div class="col-md-12">
                        <div class="back-btn font-14" @click="backFromProfileConfig">Voltar</div>

                        <div class="title-button">
                            <h2>Cadastro perfil investidor</h2>
                        </div>
                    </div>
                </div>

                <div class="panel-table-admin radius-6">
                    <div class="row head">
                        <div class="col-md-12">
                            <h6>Configurar cadastro</h6>
                            <div class="font-14">
                                Clique nos cards para habilitar ou desabilitar os campos de cadastro.
                            </div>
                        </div>
                    </div>

                    <!-- class="card radius-6 animate__animated animate__flipInX animate__slow" -->
                    <div class="cards row">
                        <div class="col-md-4 card-item" v-for="(item, index) in profileCards" :key="index">
                            <div
                                class="card radius-6"
                                data-aos="flip-up"
                                data-aos-duration="1000"
                                :data-aos-delay="index * 200"
                                v-b-toggle.sidebar-first-info
                                @click="openSidebarFirstInfo(index)"
                            >
                                <div class="content">
                                    <IconsPP :name="item.icon" />

                                    <div class="texts">
                                        <div class="title">
                                            <span class="text">{{ item.title }}</span>
                                        </div>

                                        <div class="font-14">{{ item.subtitle }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile-data" v-if="showProfileData">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="back-btn font-14" @click="backFromSeeProfile()">Voltar</div>
                        </div>
                    </div>
                </div>

                <div>
                    <MyProfile
                        :profileData="getProfileData"
                        :progress="getProgress"
                        :profileTitle="getMyProfileTitle"
                        :isPending="true"
                        :isAdmin="true"
                        :isPlatform="false"
                        :isOutsideData="true"
                    />
                </div>
            </div>
        </div>

        <b-sidebar id="sidebar-first-info" :title="'Primeiras informações'" backdrop shadow right>
            <div class="info" v-for="(item, index) in getInfoSidebar" :key="index" @click="indexToggle = index">
                <ToggleSwitchPP :isChecked="Boolean(item.value)" @changeValueAction="onChangeSwitch" />

                <div class="text">
                    {{ item.text }}
                </div>
            </div>
        </b-sidebar>

        <b-modal
            ref="block-warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="messageModal" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="setBlockUserProfile()">{{ btnMessage }}</b-button>
                <b-button variant="secondary" @click="hideModal('block-warning-modal-ref')">Cancelar</b-button>
            </div>
        </b-modal>

        <b-modal
            ref="delete-warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="messageModal" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="deleteProfile()">Sim, excluir</b-button>
                <b-button variant="secondary" @click="hideModal('delete-warning-modal-ref')">Cancelar</b-button>
            </div>
        </b-modal>

        <b-modal
            ref="success-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <SuccessMsgModal :msg="'Alteração realizada com sucesso'" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="hideModal('success-modal-ref')">Entendi</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="messageModal" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import LockPP from '@/ui/lock-pp/LockPP'
import ToggleSwitchPP from '@/ui/toggle-switch-pp/ToggleSwitchPP'
import IconsPP from '@/ui/icons-pp/IconsPP'
import MyProfile from '@/components/my-profile/MyProfile'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import { InvestorsAdminApi } from '../../../../api/admin/investors-admin-api'
import { AuthorizationApi } from '../../../../api/admin/authorization-api'
import { PlatformApi } from '../../../../api/platform'

const investorsAdminApi = new InvestorsAdminApi()
const authorizationApi = new AuthorizationApi()
const platformApi = new PlatformApi()

export default {
    name: 'ProfileAdminPage',
    components: { LockPP, ToggleSwitchPP, MyProfile, DangerModalPP, WarningMsgModal, SuccessMsgModal, IconsPP },
    data() {
        return {
            title: null,
            printObj: {
                id: 'profile-content',
                extraCss: './ProfileAdminPage-light-theme.css'
            },
            messageModal: null,
            btnMessage: null,
            indexToggle: null,
            currentRouterName: null,
            myProfileTitle: '',
            configCardSelected: null,
            openProfileConfig: false,
            showProfileData: false,
            profileSelected: null,
            currentPage: 1,
            perPage: 6,
            searchFieldText: '',
            profileData: {},
            addUserForm: {
                name: null,
                email: null,
                cpf: null,
                profile: {
                    selected: null,
                    options: [
                        { value: null, text: 'Selecione' },
                        { value: 1, text: 'Admin' },
                        { value: 2, text: 'Editor' },
                        { value: 3, text: 'Leitor' }
                    ]
                }
            },
            statusOptions: {
                1: { key: 'active', value: 'Ativo' },
                2: { key: 'blocked', value: 'Bloqueado' }
            },
            status: {
                selected: null,
                options: [
                    { value: null, text: 'Todos os status' },
                    { value: 1, text: 'Ativo' },
                    { value: 2, text: 'Bloqueado' }
                ]
            },
            messageFields: [
                {
                    key: 'nome_organizacao',
                    label: 'Nome'
                },
                {
                    key: 'cnpj',
                    label: 'CNPJ'
                },
                {
                    key: 'email',
                    label: 'E-mail'
                },
                {
                    key: 'id_status',
                    label: 'Status'
                }
            ],
            tableData: [],
            firstInfoSidebar: null,
            profileCards: [
                {
                    title: 'Primeiras informações',
                    subtitle: 'As perguntas deste bloco são de preenchimento obrigatório e acesso a plataforma.',
                    icon: 'grid'
                },
                {
                    title: 'Sobre o Responsável Legal',
                    subtitle: 'As perguntas deste bloco são de preenchimento obrigatório e acesso a plataforma.',
                    icon: 'person'
                },
                {
                    title: 'Sobre a Organização',
                    subtitle: 'Nesta seção, temos perguntas cujo preenchimento é opcional.',
                    icon: 'home'
                },
                {
                    title: 'Planejamento e Gestão',
                    subtitle: 'Nesta seção, temos perguntas cujo preenchimento é opcional.',
                    icon: 'bar-chart-2'
                },
                {
                    title: 'Sustentabilidade Financeira',
                    subtitle: 'Nesta seção, temos perguntas cujo preenchimento é opcional.',
                    icon: 'percent'
                },
                {
                    title: 'Redes e Parceiros',
                    subtitle: 'Nesta seção, temos perguntas cujo preenchimento é opcional.',
                    icon: 'people'
                },
                {
                    title: 'Resultados e Impactos',
                    subtitle: 'Nesta seção, temos perguntas cujo preenchimento é opcional.',
                    icon: 'trending-up'
                },
                {
                    title: 'Governança',
                    subtitle: 'Nesta seção, temos perguntas cujo preenchimento é opcional.',
                    icon: 'briefcase'
                },
                {
                    title: 'Anexos',
                    subtitle: 'Nessa seção, é possível inserir anexos de documentos para divulgação.',
                    icon: 'attach'
                }
            ]
        }
    },
    validations: {
        addUserForm: {
            name: { required },
            email: { required, email },
            cpf: { required }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getTableData() {
            return this.tableData
                .map(item => ({
                    id: item.id,
                    nome_organizacao: item.nome_organizacao,
                    cnpj: item.cnpj,
                    email: item.email,
                    id_status: item.id_status,
                    id_user: item.id_user
                }))
                .filter(res => res.nome_organizacao.toLowerCase().includes(this.searchFieldText.toLowerCase()))
                .filter(res => this.status.selected === null || this.status.selected === res.id_status)
        },
        rows() {
            return this.getTableData.length
        },
        getInfoSidebar() {
            return this.firstInfoSidebar
        },
        getMyProfileTitle() {
            return this.myProfileTitle
        },
        getUserStatusProfile() {
            return this.$store.state.statusProfileUserAdm
        },
        getMessageFields() {
            const columns = this.messageFields
            if ([2, 3].includes(this.getUserStatusProfile)) {
                columns.push({
                    key: 'actions',
                    label: 'Ações'
                })
            }

            return columns
        },
        getProfileData() {
            return this.profileData
        },
        getProgress() {
            return Number(this.getProfileData.allData['PrimeirasInformacao'].percentual)
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform']),
        validateStateAddUser(nameField) {
            const { $dirty, $error } = this.$v.addUserForm[nameField]
            return $dirty ? !$error : null
        },
        fetch() {
            this.currentRouterName = this.$router.history.current.name
            this.setTitlePage()

            this.profileData = {
                starsNumber: 0,
                profileName: '',
                initiativeDescription: '',
                email: '',
                city: 'São Paulo - SP',
                partners: [],
                connectionsNumber: 0,
                evaluationNumber: 0,
                selectedStatus: []
            }

            this.setIsLoading(true)

            const request =
                this.currentRouterName === 'InvestorsAdminPage'
                    ? investorsAdminApi.getInvestors()
                    : this.currentRouterName === 'InitiativesAdminPage'
                    ? investorsAdminApi.getInitiatives()
                    : investorsAdminApi.getServiceProviders()

            request
                .then(response => {
                    this.tableData = response.data
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        addUserSubmit(event) {
            this.$v.addUserForm.$touch()

            if (this.$v.addUserForm.$anyError) {
                return null
            }

            this.closeSidebarFirstInfo()
        },
        openSidebarFirstInfo(index) {
            let request = null
            this.configCardSelected = index
            this.setIsLoading(true)

            switch (index) {
                case 0:
                    request = authorizationApi.getFirstInformations(this.profileSelected.id_user)
                    break

                case 1:
                    request = authorizationApi.getLegalGuardian(this.profileSelected.id_user)
                    break

                case 2:
                    request = authorizationApi.getAboutInitiative(this.profileSelected.id_user)
                    break

                case 3:
                    request = authorizationApi.getManagementPlanning(this.profileSelected.id_user)
                    break

                case 4:
                    request = authorizationApi.getFinancialSustainability(this.profileSelected.id_user)
                    break

                case 5:
                    request = authorizationApi.getNetworksPartners(this.profileSelected.id_user)
                    break

                case 6:
                    request = authorizationApi.getResultsImpacts(this.profileSelected.id_user)
                    break

                case 7:
                    request = authorizationApi.getGovernance(this.profileSelected.id_user)
                    break

                case 8:
                    request = authorizationApi.getAttachments(this.profileSelected.id_user)
                    break

                default:
                    break
            }

            request
                .then(response => {
                    this.firstInfoSidebar = response.data.data
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        closeSidebarFirstInfo() {
            this.$root.$emit('bv::toggle::collapse', 'sidebar-add-user')
        },
        showMessagesUser(row) {
            // console.log(row)
        },
        alterProfile() {
            this.hideModal('alter-profile-modal-ref')
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        setTitlePage() {
            if (this.currentRouterName === 'InvestorsAdminPage') {
                this.title = 'Investidores'
                this.myProfileTitle = 'Perfil do Investidor'
            } else if (this.currentRouterName === 'InitiativesAdminPage') {
                this.title = 'Iniciativas'
                this.myProfileTitle = 'Perfil da Iniciativa'
            } else {
                this.title = 'Prestadores de serviço'
                this.myProfileTitle = 'Perfil do Prestador de Serviço'
            }
        },
        onChangeSwitch(value) {
            const data = this.firstInfoSidebar[this.indexToggle]
            let request = null

            this.setIsLoading(false)

            switch (this.configCardSelected) {
                case 0:
                    request = authorizationApi.updateFirstInformations(
                        data.seq,
                        Number(value),
                        this.profileSelected.id_user
                    )
                    break

                case 1:
                    request = authorizationApi.updateLegalGuardian(
                        data.seq,
                        Number(value),
                        this.profileSelected.id_user
                    )
                    break

                case 2:
                    request = authorizationApi.updateAboutInitiative(
                        data.seq,
                        Number(value),
                        this.profileSelected.id_user
                    )
                    break

                case 3:
                    request = authorizationApi.updateManagementPlanning(
                        data.seq,
                        Number(value),
                        this.profileSelected.id_user
                    )
                    break

                case 4:
                    request = authorizationApi.updateFinancialSustainability(
                        data.seq,
                        Number(value),
                        this.profileSelected.id_user
                    )
                    break

                case 5:
                    request = authorizationApi.updateNetworksPartners(
                        data.seq,
                        Number(value),
                        this.profileSelected.id_user
                    )
                    break

                case 6:
                    request = authorizationApi.updateResultsImpacts(
                        data.seq,
                        Number(value),
                        this.profileSelected.id_user
                    )
                    break

                case 7:
                    request = authorizationApi.updateGovernance(data.seq, Number(value), this.profileSelected.id_user)
                    break

                case 8:
                    request = authorizationApi.updateAttachments(data.seq, Number(value), this.profileSelected.id_user)
                    break

                default:
                    break
            }

            request
                .then(response => {
                    data.value = value
                })
                .catch(error => {
                    data.value = Number(!value)
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        makePDF() {
            const data = document.getElementById('profile-content').innerHTML
            const pdfData = window.open('', '', 'width=800,height=600')
            pdfData.document.write('<html><head>')
            pdfData.document.write('<title>PDF</title></head>')
            pdfData.document.write('<body>')
            pdfData.document.write(data)
            pdfData.document.write('</body></html')
            pdfData.document.close()
            pdfData.print()
        },
        openBlockModal(data) {
            this.profileSelected = data
            const blockStatus = this.profileSelected.id_status === 1 ? 'bloquear' : 'desbloquear'
            this.messageModal = `Tem certeza que deseja ${blockStatus} o Perfil do <b>${this.profileSelected.nome_organizacao}</b>?`
            this.btnMessage = `Sim, ${blockStatus}`
            this.showModal('block-warning-modal-ref')
        },
        openDeleteModal(data) {
            this.profileSelected = data
            this.messageModal = `Tem certeza que deseja excluir o Perfil do <b>${this.profileSelected.nome_organizacao}</b>?`
            this.showModal('delete-warning-modal-ref')
        },
        setBlockUserProfile() {
            const status = this.profileSelected.id_status === 1 ? 2 : this.profileSelected.id_status === 2 ? 1 : 2

            this.hideModal('block-warning-modal-ref')
            this.setIsLoading(true)

            const request =
                this.currentRouterName === 'InvestorsAdminPage'
                    ? investorsAdminApi.setBlockInvestor(this.profileSelected.id_user, status)
                    : this.currentRouterName === 'InitiativesAdminPage'
                    ? investorsAdminApi.setBlockInitiative(this.profileSelected.id_user, status)
                    : investorsAdminApi.setBlockServiceProvider(this.profileSelected.id_user, status)

            request
                .then(response => {
                    this.fetch()
                    this.showModal('success-modal-ref')
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        deleteProfile() {
            this.hideModal('delete-warning-modal-ref')
            this.setIsLoading(true)

            const request =
                this.currentRouterName === 'InvestorsAdminPage'
                    ? investorsAdminApi.deleteInvestor(this.profileSelected.id_user)
                    : this.currentRouterName === 'InitiativesAdminPage'
                    ? investorsAdminApi.deleteInitiative(this.profileSelected.id_user)
                    : investorsAdminApi.deleteServiceProvider(this.profileSelected.id_user)

            request
                .then(response => {
                    this.fetch()
                    this.showModal('success-modal-ref')
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        backFromProfileConfig() {
            this.openProfileConfig = false
            this.fetch()
        },
        backFromSeeProfile() {
            this.profileData = {}
            this.showProfileData = false
            this.fetch()
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
        },
        setShowProfileData(data) {
            this.setIsLoading(true)
            this.changeRegisterForm('FirstInformationForm1')

            platformApi
                .getAllProfileData(data.id_user)
                .then(response => {
                    if (response.data) {
                        const data = response.data.data
                        this.profileData.allData = data
                        this.profileData.starsNumber = data.Estrela
                        this.profileData.email = data.PrimeirasInformacao.email
                        this.profileData.profileName = data.PrimeirasInformacao.nome_organizacao
                        this.profileData.initiativeDescription = data.PrimeirasInformacao.descricao_organizacao
                        this.profileData.partners = data.PrimeirasInformacao.ods
                        this.profileData.connectionsNumber = data.Conexao
                        this.profileData.evaluationNumber = data.TotalAvaliacao
                        this.showProfileData = true

                        if (data.SobreOrganizacao) {
                            this.profileData.city = `${data.SobreOrganizacao.cidade} - ${data.SobreOrganizacao.estado}`
                        } else {
                            this.profileData.city = ''
                        }

                        // selectedStatus: [1, 2, 3, 4, 5, 6, 7, 8, 9]
                    }
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        }
    },
    watch: {
        $route(to, from) {
            if (to.name !== this.currentRouterName) {
                this.currentRouterName = to.name
                this.profileSelected = null
                this.openProfileConfig = false
                this.firstInfoSidebar = null
                this.showProfileData = false
                this.fetch()
            }
        }
    },
    created() {
        this.fetch()
    }
}
</script>

<style scope src="./ProfileAdminPage-light-theme.css"></style>
<style scope src="./ProfileAdminPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/profile-admin-page/ProfileAdminPage.vue